import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "row", "exportButton", "count"]

  static values = {
    filename: { type: String, default: "export" },
    headers: { type: Array, default: [] },
    keys: { type: Array, default: [] }
  }

  connect() {
    this.updateState()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.rowTargets.forEach(cb => {
      if (!cb.closest("tr[hidden]")) cb.checked = checked
    })
    this.updateState()
  }

  toggleRow() {
    this.updateState()
  }

  export() {
    const selectedRows = this.selectedRows
    if (selectedRows.length === 0) return

    const headers = this.headersValue
    const keys = this.keysValue

    const csvRows = [headers.join(",")]

    selectedRows.forEach(checkbox => {
      const row = checkbox.closest("tr")
      if (!row) return
      const values = keys.map(key => {
        const cell = row.querySelector(`[data-csv-key="${key}"]`)
        const val = cell ? (cell.dataset.csvValue ?? cell.textContent.trim()) : ""
        return `"${val.replace(/"/g, '""')}"`
      })
      csvRows.push(values.join(","))
    })

    const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    const timestamp = new Date().toISOString().slice(0, 10)
    link.href = url
    link.download = `${this.filenameValue}-${timestamp}.csv`
    link.click()
    URL.revokeObjectURL(url)
  }

  // --- Private ---

  get selectedRows() {
    return this.rowTargets.filter(cb => cb.checked && !cb.closest("tr[hidden]"))
  }

  get visibleRows() {
    return this.rowTargets.filter(cb => !cb.closest("tr[hidden]"))
  }

  updateState() {
    const visible = this.visibleRows
    const selected = this.selectedRows
    const allChecked = visible.length > 0 && visible.every(cb => cb.checked)

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = allChecked
      this.selectAllTarget.indeterminate = selected.length > 0 && !allChecked
    }

    if (this.hasExportButtonTarget) {
      this.exportButtonTarget.disabled = selected.length === 0
    }

    if (this.hasCountTarget) {
      this.countTarget.textContent = selected.length > 0
        ? `${selected.length} selected`
        : ""
    }
  }
}
